import {FC} from "react";
import {createPortal} from "react-dom";
import {ArrowLeftIcon} from "../atoms/Icon";

interface Props {
    src: string;
    alt?: string;
    onDismiss: () => void;
}

const PhotoReviewModal: FC<Props> = ({src, alt, onDismiss}) => {
    return createPortal(
        <div
            onClick={onDismiss}
            style={{
                position: 'fixed',
                inset: 0,
                zIndex: 1000,
                background: 'rgba(0, 0, 0, 0.9)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '24px',
            }}
        >
            <img
                src={src}
                alt={alt || ''}
                onClick={e => e.stopPropagation()}
                style={{
                    maxWidth: '90vw',
                    maxHeight: '80vh',
                    objectFit: 'contain',
                    borderRadius: '12px',
                    display: 'block',
                }}
            />
            <button
                onClick={onDismiss}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    padding: '12px 18px',
                    backgroundColor: '#1a1a1a',
                    border: '1.5px solid #444',
                    borderRadius: '24px',
                    cursor: 'pointer',
                    color: 'white',
                    fontSize: '14px',
                    fontWeight: '600',
                }}
            >
                <ArrowLeftIcon size={18}/>
                Back
            </button>
        </div>,
        document.body
    );
};

export default PhotoReviewModal;
